import { useCallback, useEffect, useRef, useState } from 'react';

const TOAST_TIMEOUT = 2500;

export const useToastState = () => {
  const [toastOpen, setToastOpen] = useState(false);
  const [toastText, setToastText] = useState('');
  const toastTimerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  const showToast = useCallback((text: string) => {
    if (toastTimerRef.current) {
      clearTimeout(toastTimerRef.current);
    }
    setToastText(text);
    setToastOpen(!!text);
    toastTimerRef.current = setTimeout(
      () => setToastOpen(false),
      TOAST_TIMEOUT,
    );
  }, []);

  useEffect(
    () => () => {
      if (toastTimerRef.current) {
        clearTimeout(toastTimerRef.current);
      }
    },
    [],
  );

  return { toastOpen, toastText, showToast };
};
